var render = function render(){var _vm=this,_c=_vm._self._c;return _c('time',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"datetime":_vm.endDateString,"title":_vm.endDateString}},[_vm._v(" "+_vm._s(_vm.remainingTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }